import type { DeepPartial } from '@luna/utils-ts';

import type { Pip } from '../../types/Pip';

export const pipCZFeatureConfig: DeepPartial<Pip> = {
    shouldShowBackNavigationOnOrderSummary: false,
    shouldShowFullCatalogueLink: true,
    tilePriceHistoryExchangeCode: 'EAM',
};
